import firebase from "../../Config/firebase";
import React, {Component} from "react";
import {
    MDBBtn, MDBCol,
    MDBContainer,
    MDBModal,
    MDBModalBody,
    MDBModalFooter,
    MDBModalHeader, MDBNavbarNav, MDBRow,
    MDBTable, MDBTableBody,
    MDBTableHead
} from "mdbreact";
import common from "../../Utils/common.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowLeft,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import classes from "./AdminPostLish.module.css";
import {Link} from "react-router-dom";
import {
    Highlight,
} from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';
import PropTypes from 'prop-types';

const db = firebase.firestore()

const searchClient = algoliasearch(
    'B1G2GM9NG0',
    'aadef574be1f9252bb48d4ea09b5cfe5'
);

Hit.propTypes = {
    hit: PropTypes.object.isRequired,
};

function Hit(props) {
    console.log(props)
    return (
        <tr>
            <td>
            </td>
            <td className={classes.hitName}><Highlight attribute="title" hit={props.hit}/></td>
            <td></td>
            <td>
            </td>
            <td>
            </td>
            w
        </tr>
    );
}

class AdminPostList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            posts: [],
            isBannerLoaded: false,
            banner: [],
            model: false,
            isOpen: false,
            aidToBeDelete: '',
            community: {},
            lastObjectCreateDate: [],

            condition: {
                turnPage: '',
                isPublish: '',
            }
        }
    }


    componentDidMount() {
        this.getPost(this.state.condition, "")
    }

    getPost = async (condition, type, data) => {
        console.log(data)
        // let newData = {}
        // if(typeof data !== 'undefined'){
        //     newData = {
        //         seconds : data.seconds,
        //         nanoseconds: data.nanoseconds
        //     }
        // }
        const getState = await new Promise((resolve, reject) => {
            let dbRef = db.collection('Post')
                .limit(10)
                .orderBy('createDate', 'desc')

            // let conditionArr =
            //     [
            //         "type == 'org-community'",
            //         // "communityID == " + communityID
            //     ]
            //
            // if (condition.hasOwnProperty('categoryID') && condition.categoryID !== '') {
            //     // conditionArr.push("categoryID == " + condition.categoryID)
            //     // dbRef.where("categoryID == " + condition.categoryID)
            // }

            if (condition.hasOwnProperty('isPublish') && condition.isPublish !== '') {
                // conditionArr.push("isPublish == " + condition.isPublish)

                dbRef = dbRef.where("isPublish", "==", condition.isPublish)
                console.log(dbRef)
            }

            if (type === 'next') {
                console.log(data)
                dbRef
                    .startAfter(data)  // last post's createDate
                    .get()
                    .then(docs => {
                        let allPost = []
                        if (!docs.empty) {
                            docs.forEach(doc => {
                                allPost.push({
                                    ...doc.data(),
                                    id: doc.id
                                })
                            });
                        }
                        if (!Array.isArray(allPost) || !allPost.length) {
                            console.log('no more post')
                        } else {
                            console.log(allPost)
                            resolve({
                                success: true,
                                data: allPost
                            })
                        }
                    })

            } else if (type === 'prev') {

                dbRef
                    .endBefore(data)  // last post's createDate
                    .limitToLast(10)
                    .get()
                    .then(docs => {
                        let allPost = []
                        if (!docs.empty) {
                            docs.forEach(doc => {
                                allPost.push({
                                    ...doc.data(),
                                    id: doc.id
                                })
                            });
                        }
                        console.log(allPost)
                        if (!Array.isArray(allPost) || !allPost.length) {
                            console.log('no more post')
                        } else {
                            console.log(allPost)
                            resolve({
                                success: true,
                                data: allPost
                            })
                        }
                    })

            } else {
                dbRef
                    .get()
                    .then(docs => {
                        let allPost = []
                        if (!docs.empty) {
                            docs.forEach(doc => {
                                allPost.push({
                                    ...doc.data(),
                                    id: doc.id
                                })
                            });
                        }
                        resolve({
                            success: true,
                            data: allPost
                        })
                    })

            }
        })
        console.log(getState)
        if (getState.success) {
            this.setState({
                isLoaded: false,
                posts: []
            }, () => {
                this.setState({
                    posts: getState.data
                }, () => {
                    this.setState({
                        isLoaded: true
                    })
                })
            })

        }

    }


    // getMyAdminPost = () => {
    //     if (this.state.condition.hasOwnProperty('isPublish') && this.state.condition.isPublish !== '') {
    //         this.filterByIsPublish(this.state.condition.isPublish)
    //     } else {
    //         db.collection('Post')
    //             .limit(10)
    //             .orderBy('createDate', 'desc')
    //             .get()
    //             .then(docs => {
    //                 if (!docs.empty) {
    //                     let allPost = []
    //                     docs.forEach(function (doc) {
    //                         const post = {
    //                             id: doc.id,
    //                             ...doc.data()
    //                         }
    //                         allPost.push(post)
    //
    //                     })
    //                     this.setState({
    //                         posts: allPost,
    //                         last: allPost[allPost.length - 1]
    //                     }, () => {
    //                         this.setState({
    //                             isLoaded: true
    //                         }, () => {
    //                             const lastObjectCreateDate = this.state.posts[this.state.posts.length - 1].createDate
    //                             console.log(lastObjectCreateDate)
    //                             if (this.state.condition.hasOwnProperty('turnPage') && this.state.condition.turnPage === true) {
    //                                 db.collection('Post')
    //                                     .limit(10)
    //                                     .orderBy('createDate', 'desc')
    //                                     .startAfter(lastObjectCreateDate)
    //                                     .get()
    //                                     .then(docs => {
    //                                         this.setState({
    //                                             isLoaded: false
    //                                         })
    //                                         if (!docs.empty) {
    //                                             let allPost = []
    //                                             docs.forEach(function (doc) {
    //                                                 const post = {
    //                                                     id: doc.id,
    //                                                     ...doc.data()
    //                                                 }
    //                                                 allPost.push(post)
    //                                             })
    //                                             this.setState({
    //                                                 posts: allPost,
    //                                             }, () => {
    //                                                 this.setState({
    //                                                     isLoaded: true
    //                                                 })
    //                                             })
    //                                         }
    //                                     })
    //                             }
    //                         })
    //                     })
    //
    //
    //                 }
    //             })
    //
    //     }
    // }


    delPost = (val) => {
        db.collection('Post')
            .doc(val)
            .delete()
    }

    delPostFromTable = (val) => {
        db.collection('Post')
            .doc(val)
            .get()
            .then(doc => {
                let newPosts = this.state.posts.filter(word => word.id !== val)
                this.setState({
                    isLoaded: false
                }, () => {
                    this.setState({
                        posts: newPosts
                    }, () => {
                        this.setState({
                            isLoaded: true
                        })
                    })
                })
            })
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    startToSearchPost = async (searchPostStr) => {
        return await new Promise((resolve, reject) => {
            fetch("/api/search/post", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    searchPostStr: searchPostStr
                })
            }).then((res) => res.json()).then((searchResult) => {
                if (Array.length !== 0) {
                    console.log(searchResult)
                }
            })
        })
    }


    render() {
        return (
            <MDBContainer>
                <MDBRow>
                    <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>
                        <h2 className={classes.SectionTitle}>貼文管理</h2>

                        <div>
                            篩選方式：
                            <MDBBtn
                                color="secondary"
                                onClick={() => {
                                    // this.setFilteredByPublish(true)
                                    this.setState({
                                        condition: {
                                            ...this.state.condition,
                                            isPublish: !this.state.condition.isPublish || this.state.condition.isPublish === '' ? true : ""
                                        }

                                    }, () => {
                                        this.getPost(this.state.condition, "")
                                    })
                                }}>
                                公開
                            </MDBBtn>
                            <MDBBtn
                                color="secondary"
                                onClick={() => {
                                    // this.setFilteredByPublish(false)
                                    this.setState({
                                        condition: {
                                            ...this.state.condition,
                                            isPublish: this.state.condition.isPublish || this.state.condition.isPublish === '' ? false : ''
                                        }
                                    }, () => {
                                        this.getPost(this.state.condition, "")
                                    })
                                }}>
                                非公開
                            </MDBBtn>
                        </div>
                        <input type='text' onChange={(e) => this.startToSearchPost(e.target.value)}/>
                        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                            <MDBModalHeader toggle={this.toggle}>提醒</MDBModalHeader>
                            <MDBModalBody>
                                此文章會完全消失!!
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn onClick={(e) => {
                                    this.delPost(this.state.aidToBeDelete);
                                    this.delPostFromTable(this.state.aidToBeDelete);
                                    this.toggle()
                                }} className={classes.ButtonItem}>Confirm</MDBBtn>
                                <MDBBtn color="secondary" onClick={this.toggle}>Close</MDBBtn>
                            </MDBModalFooter>
                        </MDBModal>
                        <MDBTable>
                            <MDBTableHead>
                                <tr>
                                    <th>#</th>
                                    <th>標題</th>
                                    <th>狀態</th>
                                    <th>功能</th>
                                    <th>社群</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                {
                                    this.state.isLoaded ?
                                        this.state.posts.map((post, index) => {
                                            return (
                                                <tr key={post.id + 'tr'}>
                                                    <td key={post.id + 'td1'}></td>
                                                    <td key={post.id + 'td2'}>{post.title}</td>
                                                    <td key={post.id + 'td3'}>{post.isPublish ?
                                                        <FontAwesomeIcon
                                                            key={post.id + 'fa1'}
                                                            icon={faCheckCircle} className={classes.Icon}/>
                                                        : <FontAwesomeIcon
                                                            key={post.id + 'td2'}
                                                            icon={faTimesCircle} className={classes.Icon}/>
                                                    }</td>
                                                    <td key={post.id + 'td2'}>
                                                        <Link key={post.id + 'lik1'} to={{
                                                            pathname: '/admin/admin-postList/editPost/' + post.id,
                                                            state: {post: post}
                                                        }}>
                                                            <MDBBtn className={classes.ButtonItem}>Edit</MDBBtn>
                                                        </Link>
                                                        <Link key={post.id + 'lik2'} to={{
                                                            pathname: '/post/' + post.id,
                                                            state: {post: post}
                                                        }}>
                                                            <MDBBtn className={classes.ButtonItem}>View</MDBBtn>
                                                        </Link>
                                                        <MDBBtn key={post.id + 'btn1'} onClick={(event) => {
                                                            this.setState({
                                                                aidToBeDelete: post.id
                                                            })
                                                            this.toggle()
                                                        }}>Delete</MDBBtn>
                                                    </td>
                                                    <td key={post.id + 'td3'}>
                                                        {post.communityID}
                                                    </td>
                                                </tr>
                                            )
                                        }) : 'Loading'
                                }
                            </MDBTableBody>
                            <div role='group'>
                                <button
                                    onClick={(e) => {
                                        this.getPost(this.state.condition, 'prev', this.state.posts[0].createDate)
                                        {
                                            console.log(this.state.posts[0])
                                        }
                                        {
                                            console.log(this.state.posts[0].createDate)
                                        }
                                    }}
                                ><FontAwesomeIcon icon={faChevronLeft}/></button>
                                <button onClick={(e) => {
                                    this.getPost(this.state.condition, 'next', this.state.posts[this.state.posts.length - 1].createDate)
                                    console.log(this.state.posts[this.state.posts.length - 1].createDate)
                                }}><FontAwesomeIcon icon={faChevronRight}/>
                                </button>
                            </div>
                        </MDBTable>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>

        );

    }
}


export default AdminPostList